module.exports = __webpack_public_path__ + "static/slogan.7903e527.png";